import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './CurrentBillCardLoading.config.style';

const currentBillCardUpperSectionLoadingConfig = [
  {
    left: setLoadingConfigObject('square', 1, null, styles.year),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.month),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.price),
  },
];

const currentBillCardMiddleSectionLoadingConfig = [
  {
    main: setLoadingConfigObject('line', 1, null, styles.line),
  },
];

const currentBillCardLowerSectionLoadingConfig = [
  {
    left: setLoadingConfigObject('square', 1, null, styles.extraChargesText),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.overPaidBillText),
    right: setLoadingConfigObject('square', 1, null, styles.overPaidBillValue),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.extraRoamingCallsText),
    right: setLoadingConfigObject('square', 1, null, styles.extraRoamingCallsValue),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.servicesText),
  },
  {
    left: ['row', setLoadingConfigObject('circle', 4, 29, styles.serviceIcon)],
    right: setLoadingConfigObject('circle', 1, 29, styles.arrow),
  },
];

export {
  currentBillCardUpperSectionLoadingConfig,
  currentBillCardMiddleSectionLoadingConfig,
  currentBillCardLowerSectionLoadingConfig,
  shimmerPlaceholderConfig,
};
